/**
 * Order status
 */
export enum OrderStatus {

    /** Active. */
    ACTIVE = 'ACTIVE',

    /** Cancel. */
    CANCEL = 'CANCEL',

    /** Canceled. */
    CANCELED = 'CANCELED',

    /** Expired. */
    EXPIRED = 'EXPIRED',

    /** Filled. */
    FILLED = 'FILLED',

    /** Partially filled. */
    PARTIALLY_FILLED = 'PARTIALLY_FILLED',

    /** Replaced. */
    REPLACED = 'REPLACED',

    /** Rejected. */
    REJECTED = 'REJECTED',

    /** Waiting Activation. */
    WAITING_ACTIVATION = 'WAITING_ACTIVATION',

    /** Unknown. */
    UNKNOWN = 'UNKNOWN'
}
